import React from 'react';
import { Stack, Typography } from '@mui/material';
import CreditCardsWidget from '../components/dashboard/CreditCardsWidget';

const CreditCardsAccountsPage: React.FC = () => (
  <Stack spacing={2}>
    <Typography variant="h5" fontWeight={700}>
      Credit Card Accounts
    </Typography>
    <Typography variant="body2" color="text.secondary">
      Manage your credit cards, including credit limits and statement cycle settings.
    </Typography>
    <CreditCardsWidget />
  </Stack>
);

export default CreditCardsAccountsPage;
